import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import OkSVG from '../../assets/svgs/ok';
import Button from '../../components/Button';
import FgiModal from '../../components/FgiModal';
import PagePath from '../../constants/PagePath';
import { useGlobalState } from '../../hooks';
import { getLink } from '../../utils';

export const FosterCollaborationSuccessModal = ({ show, onHide }) => {
  const [{ company }] = useGlobalState();
  const [t] = useTranslation();
  const navigate = useNavigate();

  const description = (
    <>
      <div className="small-modal__ok-icon">
        <OkSVG color="#89C959" />
      </div>
      <div>{t('FosterCollaborationSuccessModal.description1')}</div>
      <br />
      <div>{t('FosterCollaborationSuccessModal.description2')}</div>
    </>
  );

  const onCloseModal = () => {
    onHide();
    navigate(getLink(company, PagePath.BOOKINGS));
  };

  return (
    <FgiModal
      title={t('Anfrage erfolgreich')}
      description={description}
      onHide={onHide}
      show={show}
      color="green"
      showCloseButton={false}
      className="small-modal"
    >
      <div className="modal-footer-button">
        <Button
          size="medium"
          onClick={onCloseModal}
          style={{ minWidth: '110px' }}
          variant="green"
        >
          {t('Fertig')}
        </Button>
      </div>
    </FgiModal>
  );
};

FosterCollaborationSuccessModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default FosterCollaborationSuccessModal;
